import { FC } from 'react'

type ModalTitleProps = {
  text: string
  styles?: string
}
const ModalTitle: FC<ModalTitleProps> = ({ text, styles }) => {
  return <h2 className={`mb-6 ${styles}`}>{text}</h2>
}

export default ModalTitle
